import {
  ADD_BAZAAR_FAILURE,
  ADD_BAZAAR_REQUEST,
  ADD_BAZAAR_RESET,
  ADD_BAZAAR_SUCCESS,
} from "../../../../redux/types/pvs"

const initialState = {
  loading: false,
  error: false,
  success: false,
  message: "",
}

const addBazaarReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_BAZAAR_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        success: false,
        message: "",
      }

    case ADD_BAZAAR_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        error: false,
        message: action.payload.message || "Something went wrong",
      }

    case ADD_BAZAAR_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error || "Something went wrong",
        success: false,
        message: "",
      }

    case ADD_BAZAAR_RESET:
      return {
        ...initialState,
      }

    default:
      return state
  }
}

export default addBazaarReducer
